import { WysiswygComponent } from '@/app/atoms/wysiswyg/wysiswyg.component';
import { BbField } from '@/app/pages/create-brief-select/ui/bb-field/bb-field';
import { MonitorTypeEnum } from '@/app/common/general-types/social-screening.dto';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CreateMonitoring } from '../../services/create-monitoring';

@Component({
  selector: 'cmb-monitoring-define',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BbField],
  templateUrl: './monitoring-define.html',
  styleUrl: './monitoring-define.scss',
})
export class MonitoringDefine {
  public readonly createMonitoringService = inject(CreateMonitoring);
  readonly monitorType = MonitorTypeEnum;

  setTitle(value: string): void {
    this.createMonitoringService.basicInfoModel.set({ briefTitle: value });
  }

  selectType(type: MonitorTypeEnum): void {
    this.createMonitoringService.monitorType.set(type);
  }

  onBriefText(html: string): void {
    this.createMonitoringService.briefTextHtml.set(html);
  }
}
